import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1012782631449952';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      // Avoid double-init (StrictMode / re-mounts)
      if (!window.fbq) {
        // Build the fbq stub queue (same shape as Meta's snippet, without the
        // brittle `s.parentNode.insertBefore` insertion that fails when no
        // <script> tag exists in the document).
        const fbq: any = function () {
          // eslint-disable-next-line prefer-rest-params
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments as any) : fbq.queue.push(arguments);
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = window._fbq || fbq;
        // Inject the real fbevents.js script safely
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
      // <noscript> fallback — guard against duplicates
      const fallbackId = `mp-meta-pixel-noscript-${PIXEL_ID}`;
      if (!document.getElementById(fallbackId)) {
        const noscript = document.createElement('noscript');
        noscript.id = fallbackId;
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.alt = '';
        img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
        noscript.appendChild(img);
        (document.head || document.body).appendChild(noscript);
      }
    } catch (err) {
      // Swallow — Meta Pixel must never break the app
      console.warn('[MetaPixel] init failed:', err);
    }
  }, []);
  return null;
}